/** The page size of the history page (that should be lazy loaded) */
export const HISTORY_PAGE_SIZE = 10;
